import * as yup from 'yup';
import { isAfter, isBefore } from 'date-fns';

export const validationSchema = yup.object().shape({
  projectName: yup.string().required('Project Name is required'),

  tentativeStartDate: yup
    .date()
    .required('Start date is required')
    .test(
      'tentativeStartDate',
      'Start date must be earlier than End date',
      function (tentativeStartDate) {
        const tentativeEndDate = this.parent.tentativeEndDate;
        if (!tentativeStartDate || !tentativeEndDate) return true;
        return isBefore(tentativeStartDate, tentativeEndDate);
      }
    ),

  tentativeEndDate: yup
    .date()
    .required('End date is required')
    .test(
      'tentativeEndDate',
      'End must be later than from date',
      function (tentativeEndDate) {
        const tentativeStartDate = this.parent.tentativeStartDate;
        if (!tentativeStartDate || !tentativeEndDate) return true;
        return isAfter(tentativeEndDate, tentativeStartDate);
      }
    ),

  projectType: yup.string().required('Project type is mandatory.'),

  hypercarePeriod: yup.number().required('Hyper Care Period is required'),

  projectMember: yup
    .string()
    .required('Project Manager / Delivery Responsible is Required'),

  hoursPerWeekForPMOrDR: yup
    .number()
    .required('Project Member/Delivery Responsible Allocation is Required')
    .test(
      'is-number',
      'Project Member / Delivery Responsible Allocation cannot be more than 40',
      function (value) {
        const isMaximumAllocation = this.parent.isMaximumAllocation;
        return value <= 40 || (value > 40 && isMaximumAllocation);
      }
    )
    .positive('Project Member/Delivery Responsible Allocation is Required')
});
